import { round } from './math';

export const getVesting = chain => {
  return new Promise((resolve, reject) => {
    chain.api.getDynamicGlobalProperties((error, result) => {
      if (error || !result) {
        reject(error);
      } else {
        const { total_vesting_shares, total_vesting_fund_steem } = result;
        resolve({ total_vesting_shares, total_vesting_fund_steem });
      }
    });
  });
};

export const getTfDelegation = (
  chain,
  account,
  total_vesting_shares,
  total_vesting_fund_steem,
) => {
  return new Promise(resolve => {
    chain.api.getVestingDelegations(account, 'travelfeed', 100, (err, res) => {
      if (res && res.length > 0) {
        const steemPower = chain.formatter.vestToSteem(
          res[0].vesting_shares,
          total_vesting_shares,
          total_vesting_fund_steem,
        );
        const amountDelegated = round(steemPower, 0);
        resolve({
          isDelegator: true,
          amountDelegated,
        });
      } else resolve({ isDelegator: false });
    });
  });
};

export const getChainPost = (chain, author, permlink) => {
  return chain.api
    .getContentAsync(author, permlink)
    .then(r => {
      return r;
    })
    .catch(() => {});
};

// Extracted from https://github.com/steemit/condenser/blob/master/src/app/utils/steemApi.js
export async function callChainBridge(chain, method, params) {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line prefer-template
    chain.api.call('bridge.' + method, params, function (err, data) {
      if (err) reject(err);
      else resolve(data);
    });
  });
}

export const getChainAccount = (chain, username) => {
  return chain.api
    .getAccountsAsync([username])
    .then(account => {
      if (account.length < 1) return undefined;

      const { posting_json_metadata, json_metadata } = account[0];

      let json = {};
      try {
        json = JSON.parse(posting_json_metadata);
      } catch {
        try {
          json = JSON.parse(json_metadata);
        } catch {
          return { name: username, displayName: username };
        }
      }
      const { profile } = json;

      if (!profile) return { name: username, displayName: username };

      const {
        name,
        profile_image,
        cover_image,
        about,
        location,
        website,
        twitter,
        facebook,
        instagram,
        youtube,
        pinterest,
      } = profile;

      return {
        name: username,
        displayName: name || username,
        profileImage: profile_image,
        coverImage: cover_image,
        about,
        location,
        website,
        twitter,
        facebook,
        instagram,
        youtube,
        pinterest,
      };
    })
    .catch(err => console.error(err));
};
